export default function ResourcesHero() {
  return (
    <section className="pt-32 pb-16 bg-gradient-to-br from-brand-50 via-white to-accent-50">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="inline-block px-4 py-1.5 bg-brand-50 border border-brand-100 rounded-full mb-6">
            <span className="text-xs font-semibold text-brand-600 tracking-widest font-heading">
              FOR FAMILIES
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight mb-6 font-heading">
            Support &amp; Resources
          </h1>
          <p className="text-lg text-gray-500 leading-relaxed font-body max-w-2xl">
            Navigating CSCF means coordinating care across multiple specialties. These resources are curated to help families find the right support — from early childhood through adulthood.
          </p>
        </div>
      </div>
    </section>
  );
}
